import { Component, inject, model } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { ProfileService } from '../../profile/services/profile.service';
import { ActivatedRoute } from '@angular/router';
import { RoleFormComponent } from "../role-form/role-form.component";
import { RoleModel } from '../../shared/models/role.model';
import { access } from 'fs';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-role-edit',
  standalone: true,
  imports: [RoleFormComponent],
  templateUrl: './role-edit.component.html',
  styleUrl: './role-edit.component.css'
})
export class RoleEditComponent {
  service = inject(RolesService)
  profile = inject(ProfileService).profile
  access = inject(AccessService).access
  route = inject(ActivatedRoute)

  id!: string | null;

  value = model<RoleModel | undefined>(undefined)

  async ngOnInit() {
    this.service.title.update((value) => 'Editar Rol')
    await this.route.paramMap.subscribe(async (params) => {
      this.id = params.get('id');
      await this.getValue(params.get('id'));
    });
  }

  async getValue(id: string | null) {
    if (id === null) {
      await this.value.update((value) => (value = undefined));
    } else {
      // this.valueService.valueDetailed(id);
      await this.service.get(id).subscribe(async (data) => {
        await this.value.update(value => (value = data as RoleModel));
      });
    }
  }
}
